import { PharmItems } from '../../models';

export class SubmitPharmReorder {
  static readonly type = '[Pharm Wizard Submission] Submit Pharm Reorder';
  constructor(
    public pharmacy: string,
    public patientId: number,
    public enterpriseOrderId: string,
    public pharmItems: PharmItems[],
    public customerId: string,
    public source: string
  ) {}
}
